(function () {
  function initPagination(root) {
    if (!root || root.dataset.rrPaginationInit === 'true') return;
    root.dataset.rrPaginationInit = 'true';

    var totalPages = parseInt(root.dataset.totalPages, 10);
    var currentPage = parseInt(root.dataset.currentPage, 10);
    var input = root.querySelector('.rr-pagination__goto-input');
    var goBtn = root.querySelector('.rr-pagination__goto-btn');
    var errorEl = root.querySelector('.rr-pagination__error');

    if (!input || !goBtn || !totalPages) return;

    input.setAttribute('max', String(totalPages));
    input.setAttribute('min', '1');

    function hideError() {
      if (!errorEl) return;
      errorEl.classList.add('visually-hidden');
      errorEl.textContent = '';
      input.classList.remove('rr-pagination__goto-input--error');
    }

    var msgEmpty = root.dataset.errorEmpty || 'Please enter a page number.';
    var msgInvalid = root.dataset.errorInvalid || 'Please enter a valid page number.';
    var msgMin = root.dataset.errorMin || 'Page must be at least 1.';
    var msgMax = root.dataset.errorMax || 'Page cannot be greater than ' + totalPages + '.';

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.remove('visually-hidden');
      input.classList.add('rr-pagination__goto-input--error');
      input.focus();
    }

    function goToPage() {
      hideError();

      var raw = input.value.trim();
      if (raw === '') {
        showError(msgEmpty);
        return;
      }

      var page = parseInt(raw, 10);
      if (isNaN(page)) {
        showError(msgInvalid);
        return;
      }

      if (page < 1) {
        showError(msgMin);
        return;
      }

      if (page > totalPages) {
        showError(msgMax);
        return;
      }

      if (page === currentPage) return;

      var url = new URL(window.location.href);
      if (page === 1) {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', String(page));
      }
      window.location.href = url.toString();
    }

    goBtn.addEventListener('click', goToPage);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        goToPage();
      }
    });
    input.addEventListener('input', hideError);
  }

  function boot() {
    document.querySelectorAll('[data-rr-pagination]').forEach(initPagination);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-rr-pagination]').forEach(function (root) {
      delete root.dataset.rrPaginationInit;
    });
    boot();
  });
})();
